import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

import { API, Auth } from 'aws-amplify';

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// redux
import { useAppDispatch, useAppSelector } from '../../hooks'
import { getFundraisingAmbassadors } from '../../managers/redux/slices/fundraising'
import { reloadAuthAccount } from '../../managers/redux/slices/authAccount'
import InviteTeamMember from '../../components/dialogs/team/InviteTeamMember'
import { COLORS } from '../../theme/muiTheme';

import { FundraisingProfile } from '../../API'
import InviteAmbassador from '../../components/dialogs/fundraising/InviteAmbassador';

export default function Donations(props: any) {

    const history = useHistory()

    // redux
    const dispatch = useAppDispatch()
    const fundraising = useAppSelector(state => state.fundraising)
    const authAccount = useAppSelector(state => state.authAccount)

    // dialog
    const [showStaffInvitationDialog, setShowStaffInvitationDialog] = useState(false)
    const [donorList, setDonorList] = useState<any>(null)

    useEffect(() => {
        (async () => {
            if (authAccount.cognitoData) {
                if (fundraising.ambassadors == null) {
                    dispatch(getFundraisingAmbassadors())
                }
            } else {
                await dispatch(reloadAuthAccount())
                if (fundraising.ambassadors == null) {
                    dispatch(getFundraisingAmbassadors())
                }
            }
        })()
    }, [])

    useEffect(() => {
        (async () => {
            if (donorList == null && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile.organizationID) {
                const apiName = 'RESTfundraising';
                const path = '/fundraising/donations';

                const user = await Auth.currentAuthenticatedUser()

                console.log(user)

                const response: any = await API.get(apiName, path, { "queryStringParameters": { "jwt": user.signInUserSession.idToken.jwtToken, organizationID: authAccount.selectedStaffProfile?.organizationID } });

                console.log(response)
                if (response && response.donations) {
                    setDonorList(response.donations)
                }
            }
        })()
    }, [authAccount])

    return (
        <div className="p-5 d-flex flex-column justify-content-start">
            <div className="d-flex flex-row justify-content-between w-100">
                <Typography variant="h3">{donorList && donorList.length ? donorList.length : ''} Donation{donorList && donorList.length && donorList.length > 1 ? 's' : ''}</Typography>
            </div>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Phone Number</TableCell>
                            <TableCell align="left">Address</TableCell>
                            <TableCell align="left">Donation Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            donorList && donorList.length && donorList.length > 0 ?
                                donorList.map((donation: any) => {
                                    return (
                                        <TableRow
                                            key={donation.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: COLORS.ICE } }}
                                        // onClick={() => { history.push(`/admin/profile?id=${fundraisingProfile && fundraisingProfile.authAccount ? fundraisingProfile.authAccount.id : ''}`) }}
                                        >
                                            <TableCell align="left">
                                                {donation.customer_email ? donation.customer_email : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {donation.donorName ? donation.donorName : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {donation.checkoutSession ? JSON.parse(donation.checkoutSession).customer_details.phone : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {donation.checkoutSession ? `${JSON.parse(donation.checkoutSession).customer_details.address.line1} ${JSON.parse(donation.checkoutSession).customer_details.address.city} ${JSON.parse(donation.checkoutSession).customer_details.address.state} ${JSON.parse(donation.checkoutSession).customer_details.address.postal_code}` : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {donation.checkoutSession ? `$${Number(JSON.parse(donation.checkoutSession).amount_total) / 100}` : ''}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                                :
                                <div></div>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {/* DIALOG */}
            <InviteAmbassador visible={showStaffInvitationDialog} onClose={() => setShowStaffInvitationDialog(false)} />

        </div>
    )
}